'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIButton from 'UIComponents/button/UIButton';
import UISelect from 'UIComponents/input/UISelect';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import * as HubUsersActions from 'FileManagerCore/actions/HubUsers';
import { getUserEmailAddress } from 'FileManagerCore/selectors/Auth';
import { getHubUsersEmailOptionsForSelect, getShouldFetchHubUsers } from 'FileManagerCore/selectors/HubUsers';
import { createHubUserEmailOptionsForSelect } from 'FileManagerCore/utils/hubUsers';
import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getI18nKey = suffix => `FileManagerDashboard.exportModal.${suffix}`;
const getPromptText = email => I18n.text(getI18nKey('addEmail'), {
  email
});
class ChooseEmailAddressesForExportModal extends Component {
  constructor(...args) {
    super(...args);
    this.getDefaultValue = () => [this.props.userEmailAddress];
    this.loadOptions = (input, callback) => {
      const {
        shouldFetchHubUsers,
        fetchHubUsers,
        options
      } = this.props;
      if (!shouldFetchHubUsers) {
        callback(null, {
          options
        });
        return;
      }
      fetchHubUsers(results => {
        callback(null, {
          options: createHubUserEmailOptionsForSelect(results)
        });
      });
    };
  }
  componentDidMount() {
    this.props.handleSelectChange(SyntheticEvent(this.getDefaultValue()));
  }
  render() {
    const {
      handleCloseModal,
      handleSelectChange,
      handleExport,
      isExportButtonDisabled,
      options
    } = this.props;
    return /*#__PURE__*/_jsxs(UIModal, {
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: handleCloseModal
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getI18nKey('exportFiles')
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getI18nKey('bodyDialog')
          })
        }), /*#__PURE__*/_jsx(UISelect, {
          multi: true,
          onChange: handleSelectChange,
          options: options,
          promptTextCreators: getPromptText,
          placeholder: I18n.text(getI18nKey('placeholder')),
          onInputChange: this.onInputChange,
          noResultsText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getI18nKey('noResultsText')
          }),
          defaultValue: this.getDefaultValue(),
          loadOptions: this.loadOptions
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          disabled: isExportButtonDisabled,
          use: "primary",
          onClick: handleExport,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getI18nKey('sendButton')
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: handleCloseModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "FileManagerDashboard.actions.cancel"
          })
        })]
      })]
    });
  }
}
ChooseEmailAddressesForExportModal.propTypes = {
  userEmailAddress: PropTypes.string.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  handleSelectChange: PropTypes.func.isRequired,
  handleExport: PropTypes.func.isRequired,
  isExportButtonDisabled: PropTypes.bool.isRequired,
  fetchHubUsers: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.string
  })).isRequired,
  shouldFetchHubUsers: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  userEmailAddress: getUserEmailAddress(state),
  options: getHubUsersEmailOptionsForSelect(state),
  shouldFetchHubUsers: getShouldFetchHubUsers(state)
});
const mapDispatchToProps = {
  fetchHubUsers: HubUsersActions.fetchHubUsers
};
export default connect(mapStateToProps, mapDispatchToProps)(ChooseEmailAddressesForExportModal);